var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeoWidget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.904,
    height: 14.88,
    viewBox: "0 0 11.904 14.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon-geopoint",
    d: "M13.952,11.254a1.3,1.3,0,1,0-.921-.381A1.255,1.255,0,0,0,13.952,11.254Zm0,6.157a21.785,21.785,0,0,0,3.655-4.083A6.194,6.194,0,0,0,18.788,10.1a4.842,4.842,0,0,0-1.4-3.59,4.684,4.684,0,0,0-3.432-1.4,4.684,4.684,0,0,0-3.432,1.4,4.842,4.842,0,0,0-1.4,3.59,6.1,6.1,0,0,0,1.209,3.227A23.656,23.656,0,0,0,13.952,17.411Zm0,1.469a24.734,24.734,0,0,1-4.473-4.734A7.362,7.362,0,0,1,8,10.1,5.754,5.754,0,0,1,9.795,5.655a6.048,6.048,0,0,1,8.314,0A5.754,5.754,0,0,1,19.9,10.1a7.362,7.362,0,0,1-1.479,4.046A24.734,24.734,0,0,1,13.952,18.88ZM13.952,10.1Z",
    transform: "translate(-8 -4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoWidget);
export default __webpack_public_path__ + "static/media/GeoWidget.25d04097.svg";
export { ForwardRef as ReactComponent };